import { useContext } from "react";
import { context } from "@/Layout";

const MenuToggle = () => {
  const { isOpened, toggleIsOpened } = useContext(context);

  return (
    <div
      className={`hamburger z-20 relative transition-all hover:cursor-pointer lg:hidden ${
        isOpened ? "active" : ""
      }`}
      onClick={() => toggleIsOpened("toggle")}
      role="button"
      tabIndex={0}
    >
      <div className="hamburger-nav">
        <span className="line block h-[2px] w-6 bg-white mb-1 rounded-full top" />
        <span className="line block h-[2px] w-6 bg-white mb-1 rounded-full middle" />
        <span className="line block h-[2px] w-6 bg-white mb-1 rounded-full  bottom" />
      </div>
    </div>
  );
};

export default MenuToggle;
